(function () {
  "use strict";

  SetDeadlineTraineesCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('SetDeadlineTraineesCtrl', SetDeadlineTraineesCtrl);

  function SetDeadlineTraineesCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      deadlineDate:''
    };

    $scope.setDeadlineTrainees = function() {
      $scope.modal.status = 'saving';
      $scope.$emit('setDeadlineTraineesConfirmEvent', $scope.modal.data, function() {
        $scope.dismiss();
        $timeout(function() {$scope.modal.status = ''}, 500);
      });
    };

    $scope.$on('traineesToSetDeadlineEvent', function(event, numberOfTrainees, deadlineDate) {
      $scope.modal.status = '';
      $scope.modal.data = {};
      $scope.modal.content = numberOfTrainees;
      $scope.modal.deadlineDate = deadlineDate;
    });
  }

})();
